import PropTypes from 'prop-types';
import React from 'react';

import TemplateDefault from '../../templates/default/default';
import ContentBlocks from '../../organisms/content-blocks/contentBlocks.withRedux';
import LandingStage from '../../organisms/landing-stage/landingStage';
import Stage from '../../organisms/stage/stage';
import TagFilter from '../../molecules/tag-filter/tagFilter.withRedux';
import TagFilterResults from '../../organisms/tag-filter-results/tagFilterResults';
import FilterSwitch from '../../molecules/filter-switch/filterSwitch';

const Overview = ({ overviewData }) => {
  const { listData, embeds, allTypeTags, slug, filterCategories, lang } = overviewData;

  // didnt work without listData...
  if (!listData) {
    return (
      <TemplateDefault invertedHeader backgroundGradient>
        <>
          <LandingStage />
          {embeds && <ContentBlocks noShareLinks />}
        </>
      </TemplateDefault>
    );
  }

  // original
  return (
    <TemplateDefault invertedHeader backgroundGradient>
      {listData.meta && listData.meta.pagination.current_page === 1 && (
        <>
          <Stage />
          {embeds && <ContentBlocks noShareLinks />}
        </>
      )}

      {!listData.meta && (
        <>
          <Stage />
          {embeds && <ContentBlocks noShareLinks />}
        </>
      )}

      {slug === 'veranstaltungen' || slug === 'events' ? (
        <FilterSwitch listData={listData} categories={filterCategories} locale={lang} />
      ) : null}

      {allTypeTags && allTypeTags.length ? (
        <TagFilter topPadding={listData.meta ? listData.meta.pagination.current_page > 1 : false} />
      ) : null}
      {slug !== 'veranstaltungen' && slug !== 'events' ? <TagFilterResults /> : null}
    </TemplateDefault>
  );
};

Overview.propTypes = {
  overviewData: PropTypes.shape({
    typeTags: PropTypes.arrayOf(PropTypes.shape()),
    allTypeTags: PropTypes.arrayOf(PropTypes.shape()),
    filterCategories: PropTypes.shape(),
    datesList: PropTypes.arrayOf(PropTypes.shape()),
    embeds: PropTypes.arrayOf(PropTypes.shape()),
    eventsList: PropTypes.arrayOf(PropTypes.shape()),
    listData: PropTypes.shape({
      meta: PropTypes.shape({
        pagination: PropTypes.shape()
      }).isRequired
    }).isRequired,
    lang: PropTypes.string,
    slug: PropTypes.string
  }).isRequired
};

export default Overview;
